module.exports = __webpack_public_path__ + "static/media/Screenshot_6.cc57e0c8.png";